/**
 * 0.158 (ADR 0164): Vorladen mit Absicht. Beim Zeigen, Fokussieren oder Antippen eines Werkzeugwechsels werden Zielmodul
 * und dessen kleine Erstabfrage vorbereitet – höchstens zwei spekulative Vorbereitungen gleichzeitig, jede höchstens alle
 * 30 s, nichts im Datensparmodus. Keine Dateien, Vorschauen oder ganzen Bestände.
 */
type Prep = (projectId: string) => Array<Promise<unknown>>;
const preps = new Map<string, Prep>();
const recent = new Map<string, number>();
let active = 0;
export const MAX_SPECULATIVE = 2;

export function registerPrepare(tool: string, fn: Prep) {
  preps.set(tool, fn);
}

export function saveData(): boolean {
  return (navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData === true;
}

export function prepare(tool: string, projectId: string) {
  const fn = preps.get(tool);
  if (!fn || saveData() || active >= MAX_SPECULATIVE) return;
  const key = `${projectId}:${tool}`;
  const now = Date.now();
  if (now - (recent.get(key) ?? 0) < 30_000) return;
  recent.set(key, now);
  active++;
  void Promise.allSettled(fn(projectId)).finally(() => active--);
}
